<template>
   <section class="section section-lg bg-default">
         <div class="container container-wide" id="notfound">

            <h3>404 ページが見つかりません</h3>
            <h4 >(PAGE NOT FOUND)</h4>
            <br>
            <p>申し訳ありませんが、お探しのページは存在しません。</p>
            <p>(Sorry, the page you are looking for does not exist.)</p>
         </div>
         <h3></h3>
   </section>
</template>

<style scoped>
div#container {
  width: 175mm;
  padding: 5mm 8mm;
}

#notfound {
    margin-top: 50px;
    margin-bottom: 150px;
    text-align: center;
}

p,h3,h4 {
    color:#000;
}

body section .login-container-child {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
}
body section.fullwidth-page {
    min-height: auto !important;
}
body section > div.login-container {
    padding-top: 0px !important;
}

</style>

<script>

export default {
    created() {
      this.$router.push('/products');
    }
};
</script>
